import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/PrimeNg.module';
import { MainExcelPagoComponent } from './main-excel-pago/main-excel-pago.component';
import { GenerarExcelPagoComponent } from './generar-excel-pago/generar-excel-pago.component';



@NgModule({
  declarations: [
    MainExcelPagoComponent,
    GenerarExcelPagoComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    PrimeNgModule,
  ],
  exports: [
    MainExcelPagoComponent,
  ]
})
export class ExcelPagoModule { }
